/* jshint undef: true, unused: true */

const convertLegacyDropdownOptions = require('../convertLegacyDropdownOptions');

const notJquery = require('../../../../js_functions/form-builder/js/not-jquery');
const deviceTypeValues = convertLegacyDropdownOptions(require('./equipment__device-type.js'));
const operatorValues = convertLegacyDropdownOptions(require('./equipment__operator.js'));
const usageValues = convertLegacyDropdownOptions(require('./equipment__usage.js'));
const visibleFields = require('./equipment-visible-client-fields')();
const equipmentService = require('./equipment-service');
const objectPathToKey = require('../../../../js_functions/form-builder/js/objectPathToKey');
const equipsRESTService = require('./equipment-rest-service');
const globals = require('../../../../js_functions/globalsWrapper')();

const mapProperties = function (chosenDrug, parentClass) {
  if (typeof chosenDrug !== 'undefined') {
    [
      'type',
      'subType',
      'manufacturer',
      'supplyCategory',
      'supplyClassification',
      'supplier',
      'model',
      'sourceId'
    ]
      .map(function(prop) {
        return { dataName: prop, elementName: prop };
      })
      .concat([
        { dataName: 'id', elementName: 'equipmentId' },
        { dataName: 'brand', elementName: 'brandName' },
        { dataName: 'genericName', elementName: 'productName' }
      ])
      .forEach(function (prop) {
        var structure = parentClass.settings.structure,
            propData  = chosenDrug[prop.dataName];

        var objectPath = objectPathToKey(structure, prop.elementName);
        if(objectPath) {
          parentClass.updateField(objectPath.object, propData);
        }
      });
  }
};

module.exports = function formBuilderStructure(data) {

  const equipmentAPIService = (globals.equipmentV2Enabled ? equipsRESTService : equipmentService);
  const newIncident = globals.isNewRecord;

  // Field Definitions
  const special = {
    // 'Is Quantity defective' 	x	Free Text Field, gqlid=1
    // Date put in use 		Date Field, gqlid=2
    // Date of last service		Date Field, gqlid=3
    // Expiry date
    expiryDate: {
      label       : 'DEVICES.V2.FORM.LABEL.EXPIRY_DATE',
      elementType : 'date',
      graphQLID   : 5,
      attributes  : {
        name         : 'expiryDate',
        class        : ['equipment-field'],
        placeholder  : 'DEVICES.V2.FORM.PLACEHOLDER.EXPIRY_DATE_FORMAT',
        autocomplete : 'off'
      },
      dateFormat        : data.globalDateFormat
    },
    dateManufactured: {
      label     : 'DEVICES.V2.FORM.LABEL.DATE_MANUFACTURED',
      elementType : 'date',
      graphQLID : 6,
      attributes: {
        name         : 'dateManufactured',
        class        : ['equipment-field'],
        placeholder  : 'DEVICES.V2.FORM.PLACEHOLDER.DATE_MANUFACTURED_FORMAT',
        autocomplete : 'off'
      },
      dateFormat        : data.globalDateFormat
    },
    searchRow: {
      elementType: 'multicolumn',
      wrapperClass : ['grid-row'],
      inputChildren: {
        equipmentSearch: {
          mandatoryPopoverOverride : true,
          label                    : 'DEVICES.V2.FORM.LABEL.SEARCH',
          labelClass               : 'col--no-margin',
          wrapperClass             : 'combo-search-field',
          inputLayoutClass         : 'col-12',
          comboWrapperClass        : ['col-12', 'col--no-padding'],
          attributes               : {
            name         : 'equipmentSearch',
            id           : 'equipmentSearch',
            required     : 'required',
            class        : ['equipment-field']
          },
          dataObjectNameKey : 'equipment',
          validation : {
            combo : ['brandSearchText']
          },
          page         : 0,
          elementType  : 'combo',
          messages : {
            required : 'MEDICATIONS.V2.FORM.MESSAGE.DRUG_ADMINISTERED_DOSAGE_UNIT'
          },
          init: function (wrapper, foBu) {
            // Button must trigger the search functionality using the contents of the other two fields.
            var cssClassIconDisabled = '__icon--disabled';
            var $textInput           = $(wrapper).find('#brandSearchText_equipmentform').addClass('equipment-field');
            var $selectInput         = $(wrapper).find('#brandSearchField_equipmentform_title').addClass('equipment-field');
            var $button              = $('<span>')
              .addClass('foBu__search-icon')
              .addClass(cssClassIconDisabled);

            function toggleButtonState() {
              var values = foBu.getInputValues();
              var text = values.brandSearchText;
              var field = values.brandSearchField;

              $button.removeClass(cssClassIconDisabled);
              if (text.length < 2 || field === '') {
                $button.addClass(cssClassIconDisabled);
              }
            }

            function enterPressed(event) {
              // Check if ENTER was pressed
              if (event.keyCode === 13) {
                $button.trigger('click');
              }
            }

            function activateModal() {
              const inputValues = foBu.getInputValues();
              const searchTerm = inputValues.equipmentSearch.brandSearchText;
              const searchField = inputValues.equipmentSearch.brandSearchField;
              if (!$(this).hasClass(cssClassIconDisabled)) {
                getEquipmentSearchResultsModal(searchTerm, searchField);
              }
            }

            function chooseEquipmentHandler(event) {
              closeEquipmentSearchModal();
              $textInput.val(event.detail.value);
              mapProperties(event.detail.equipment, foBu);
            }

            $textInput
              .on('keyup', toggleButtonState)
              .on('change', toggleButtonState)
              .on('onClearedEvent', toggleButtonState)
              .on('keypress', enterPressed);

            $selectInput
              .on('change', toggleButtonState)
              .on('onClearedEvent', toggleButtonState)
              .on('keypress', enterPressed);

            $button.on('click', activateModal);

            $selectInput.parent().append($button);

            document.addEventListener('onEquipmentDrugChoseEvent', chooseEquipmentHandler);
          },
          inputChildren : {
            brandSearchText : {
              comboParent      : 'equipmentSearch',
              inputLayoutClass : ['col-6', 'col--no-margin'],
              attributes       : {
                name         : 'brandSearchText',
                autocomplete : 'off'
              }
            },
            brandSearchField : {
              comboParent      : 'equipmentSearch',
              inputLayoutClass : ['col-6', 'col--no-margin'],
              elementType      : 'typeahead',
              attributes       : {
                name        : 'brandSearchField',
              },
              options : [
                { label: 'DEVICES.V2.FORM.LABEL.BRAND_NAME', value: 'brand', active: true, fieldName: 'brandName' },
                { label: 'DEVICES.V2.FORM.LABEL.SUPPLY_CATEGORY', value: 'supplyCategory', active: true, fieldName: 'supplyCategory' },
                { label: 'DEVICES.V2.FORM.LABEL.SUPPLY_CLASSIFICATION', value: 'supplyClassification', active: true, fieldName: 'supplyClassification' },
                { label: 'DEVICES.V2.FORM.LABEL.SUPPLIER', value: 'supplier', active: true, fieldName: 'supplier' },
                { label: 'DEVICES.V2.DISPLAY.LABEL.MODEL', value: 'model', active: true, fieldName: 'model' },
                { label: 'DEVICES.V2.DISPLAY.LABEL.MANUFACTURER', value: 'manufacturer', active: true, fieldName: 'manufacturer' },
                { label: 'DEVICES.V2.FORM.LABEL.TYPE', value: 'type', active: true, fieldName: 'type' },
                { label: 'DEVICES.V2.FORM.BUTTON.SUB_TYPE', value: 'subType', active: true, fieldName: 'subType' },
                { label: 'DEVICES.V2.MESSAGE.SEARCH_TABLE.GENERIC_NAME', value: 'genericName', active: true, fieldName: 'productName' },
              ].filter(option => visibleFields.includes(option.fieldName)),
              useLegacyDropDownComponent:true,
              useOptionsValue:true
            },
          }
        }
      },
    },
    columnButtonRow : {
      page         : 0,
      wrapperClass : 'col-3',
      elementType  : 'button',
      onClick      : 'clearEquipmentFields',
      attributes   : {
        id    : 'equipment-clear-column',
        class : ['dtx-button', 'dtx-button-small', 'button-clear'],
        html  : 'DEVICES.V2.FORM.BUTTON.CLEAR',
        type: 'button'
      }
    },
    answersId : {
      elementType : 'hidden',
      attributes  : {
        name  : 'answersId',
        donotclear : true
      }
    },
    equipmentId : {
      elementType : 'hidden',
      attributes  : {
        name  : 'equipmentId'
      }
    },
    dataViewRecordIndex : {
      elementType : 'hidden',
      attributes  : {
        name       : 'dataViewRecordIndex',
        donotclear : true
      }
    }
  };
  var freeTexts = {
    // Core: Always display these fields.
    // Assume ids should be hardcoded for now.
    // Ids can be strings.
    // Make a list of core fields which are automatically decorated.
    brandName: {
      label       : 'DEVICES.V2.FORM.LABEL.BRAND_NAME',
      populatedBy : 'equipmentSearch',
    },
    type: {
      label       : 'DEVICES.V2.FORM.LABEL.TYPE',
      populatedBy : 'equipmentSearch',
      graphQLID   : 0
    },
    subType: {
      label       : 'DEVICES.V2.FORM.BUTTON.SUB_TYPE',
      populatedBy : 'equipmentSearch',
      graphQLID   : 0
    },
    supplyCategory: {
      label       : 'DEVICES.V2.FORM.LABEL.SUPPLY_CATEGORY',
      populatedBy : 'brandName'
    },
    supplyClassification: {
      label       : 'DEVICES.V2.FORM.LABEL.SUPPLY_CLASSIFICATION',
      populatedBy : 'brandName'
    },
    productName: {
      // GenericName
      label       : 'DEVICES.V2.FORM.LABEL.PRODUCT_NAME',
      populatedBy : 'equipmentSearch',
      graphQLID   : 0
    },
    manufacturer: {
      label       : 'DEVICES.V2.FORM.LABEL.MANUFACTURER',
      populatedBy : 'equipmentSearch',
      graphQLID   : 0
    },
    // End of Core
    model: {
      label     : 'DEVICES.V2.FORM.LABEL.MODEL',
      graphQLID : 0
    },
    catalogueNumber: {
      label     : 'DEVICES.V2.FORM.LABEL.CATALOGUE_NUMBER',
      graphQLID : 8
    },
    batchNumber: {
      label     : 'DEVICES.V2.FORM.LABEL.BATCH_NUMBER',
      graphQLID : 12
    },
    quantityUsed: {
      label     : 'DEVICES.V2.FORM.LABEL.QUANTITY_USED',
      graphQLID : 4
    },
    serialNumber: {
      label      : 'DEVICES.V2.FORM.LABEL.SERIAL_NUMBER',
      visibility : globals.vanessasLawEnabled,
      graphQLID  : 7
    },
    supplier: {
      label     : 'DEVICES.V2.FORM.LABEL.SUPPLIER',
      graphQLID : 9
    },
    currentLocationOfDevice: {
      label     : 'DEVICES.V2.FORM.LABEL.CURRENT_DEVICE_LOCATION',
      graphQLID : 0
    },
    sourceId: {
      label      : 'DEVICES.V2.FORM.LABEL.DEVICE_ID',
      visibility : globals.vanessasLawEnabled,
      graphQLID  : 0
    }
  };
  var dropdowns = {
    deviceType: {
      label   : 'DEVICES.V2.FORM.LABEL.DEVICE_TYPE',
      options : deviceTypeValues
    },
    operator: {
      label   : 'DEVICES.V2.FORM.LABEL.DEVICE_OPERATOR',
      options : operatorValues
    },
    usage: {
      label   : 'DEVICES.V2.FORM.LABEL.DEVICE_USAGE',
      options : usageValues
    }
  };
  const requiredFields = [
    'searchRow',
    'brandName',
    'equipmentId',
    'dataViewRecordIndex',
  ].concat(newIncident ? [] : [
    'model',
    'supplyCategory',
    'supplyClassification',
    'deviceType',
    'quantityUsed',
    'batchNumber',
    'expiryDate',
    'catalogueNumber',
    'supplier',
    'operator',
    'usage',
    'currentLocationOfDevice',
  ]);
  var disabledFields = [
    'brandName',
    'type',
    'subType',
    'productName',
    'manufacturer',
    'answersId',
    'supplier',
    'supplyCategory',
    'supplyClassification',
    'model',
    'sourceId'
  ];

  // Field Order.
  return [
    'columnButtonRow',
    'searchRow',
    'brandName',
    'type',
    'subType',
    'productName',
    'manufacturer',
    'model',
    'supplyCategory',
    'supplyClassification',
    'deviceType',
    'quantityUsed',
    'batchNumber',
    'expiryDate',
    'dateManufactured',
    'catalogueNumber',
    'supplier',
    'sourceId',
    'serialNumber',
    'operator',
    'usage',
    'currentLocationOfDevice',
    'answersId',
    'equipmentId',
    'dataViewRecordIndex'
  ].reduce(function(structureCarried, key) {
    const required = requiredFields.includes(key);
    const disabled = disabledFields.indexOf(key) > -1;

    // Set up the config structure for a field.
    const fieldStructure = notJquery.deepMerge(
      {
        // Intial structure.
        attributes: {
          name  : key,
          class : ['equipment-field', 'col--no-margin']
        },
        wrapperClass : 'grid-row',
        labelClass   : 'col--no-margin',
        visibility   : visibleFields.indexOf(key) > -1
      },
      [
        // Pick the config for the fieldStructure.
        [freeTexts, freeTexts[key]],
        [
          dropdowns,
          Object.assign(
            {
              elementType : 'typeahead',
              attributes  : {
                name        : key,
                placeholder : 'DEVICES.V2.FORM.PLACEHOLDER.SELECT_ONE'
              },
              useLegacyDropDownComponent:true
            },
            dropdowns[key]
          )
        ],
        [special, special[key]]
      ].find(function(item) {
        return item[0][key];
      })[1]
    );

    // Endow for special cases.
    if (required && !disabled) {
      fieldStructure.validation = {};
      fieldStructure.validation.required = true;
      fieldStructure.attributes.required = 'required';
    }
    if (disabled) {
      fieldStructure.attributes.disabled = 'disabled';
    }

    // Start containing div section. This is to fix mandatory field styling.
    const containerRow = {
      page          : 0,
      elementType   : 'multicolumn',
      wrapperClass  : 'grid-row',
      inputChildren : {},
      visibility    : fieldStructure.visibility,
      attributes    : {
        name: key + '-row',
        id: key + '-row'
      }
    };
    if (key !== 'columnButtonRow') {
      fieldStructure.wrapperClass = 'col-12';
    } else {
      containerRow.wrapperClass = ['grid-row', 'column-top-row']
    }
    containerRow.inputChildren[key] = fieldStructure;
    // End containing div section

    structureCarried[key + 'ContainerRow'] = containerRow;
    return structureCarried;
  }, {});
};
